var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-guide"},[_c('div',{staticClass:"card-guide-body"},[_c('iframe',{attrs:{"src":"https://docs.google.com/forms/d/e/1FAIpQLSf_4haMTqE1Riw59acVNz1l9RjngoR4JfTPu9oDLP-wmEt4Zg/viewform?embedded=true","width":"640","height":"542","frameborder":"0","marginheight":"0","marginwidth":"0"}},[_vm._v("\n      Loading…\n    ")])])])
}]

export { render, staticRenderFns }